import { render, staticRenderFns } from "./counsellors.vue?vue&type=template&id=3a5c6dfb&scoped=true&"
import script from "./counsellors.vue?vue&type=script&lang=js&"
export * from "./counsellors.vue?vue&type=script&lang=js&"
import style0 from "./counsellors.vue?vue&type=style&index=0&id=3a5c6dfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c6dfb",
  null
  
)

export default component.exports